import React from 'react';
import { Component } from "puzzle"

export type PROPS = {
  editorResponse: any
  onlineEditorUrl: {
    editorUrl: string
  }[]
};

export type STATE = {}

class ExportViewer extends Component<PROPS, STATE> {
  renderBody = () => {
    return (
      <iframe
        title={this.props.onlineEditorUrl[0].editorUrl} src={this.props.onlineEditorUrl[0].editorUrl}
        style={{ height: '100%', width: '100%' }}
      />
    );
  }
}

export default ExportViewer;
